// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2V41j","fileBtn":"File_fileBtn__2YI7y","closeBtn":"File_closeBtn__1rZPR","fileSelected":"File_fileSelected__3j9PN","disabled":"File_disabled__3ZKyI"};